import { useErrorHandler } from 'react-error-boundary';
import { ReadEmployee, useGetStaffByIdQuery } from '../gql/graphql.generated';

export const useStaffById = (id: string) => {
  const handleError = useErrorHandler();

  const [{ data: userData, error: userError }] = useGetStaffByIdQuery({
    variables: {
      id
    },
    requestPolicy: 'network-only'
  });

  if (userError) {
    handleError(userError);
  }

  return userData?.employee as ReadEmployee | undefined;
};
